import { render, staticRenderFns } from "./userTable.vue?vue&type=template&id=06dd26ae&"
import script from "./userTable.vue?vue&type=script&lang=js&"
export * from "./userTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports